import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ServicesHelper } from '../helpers';

@Injectable()
export class NoticeService extends BaseService<any> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string) {
    const url: string = apiUrl + 'notice/';
    super(apiUrl, url, httpClient);
  }

  generateNotices(date: Date | null): Observable<any> {
    const url: string = this.url + 'generate-notices/' + date.toISOString();
    const response: Observable<any> = this.httpClient.get<any>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

}
